import eagleviewIcon from "../../assets/integrations/eagleview.png";
import signnowIcon from "../../assets/integrations/signnow.svg";
import boldsignIcon from "../../assets/integrations/boldsign.svg";

import type { IntegrationId } from "../../interfaces";

export type IntegrationStatus = "connected" | "not_configured";
export type IntegrationCategory = "Measurements" | "E-Signature";
export type { IntegrationId };

export interface IntegrationField {
    key: string;
    label: string;
    helperText: string;
    placeholder: string;
    secret?: boolean;
}

export interface IntegrationDefinition {
    id: IntegrationId;
    name: string;
    description: string;
    category: IntegrationCategory;
    docsUrl?: string;
    icon: string;
    accent: string;
    fields: IntegrationField[];
}

export const INTEGRATIONS: IntegrationDefinition[] = [
    {
        id: "eagleview",
        name: "EagleView",
        description:
            "Pull roof measurement reports and order data for project setup.",
        category: "Measurements",
        docsUrl: "https://www.eagleview.com/",
        icon: eagleviewIcon,
        accent: "#3E649B",
        fields: [
            {
                key: "clientId",
                label: "Client ID",
                helperText: "EagleView API client ID",
                placeholder: "ev_client_…",
            },
            {
                key: "clientSecret",
                label: "Client Secret",
                helperText: "EagleView API client secret",
                placeholder: "••••••••",
                secret: true,
            },
        ],
    },
    {
        id: "signnow",
        name: "SignNow",
        description: "Send contracts and documents for electronic signature.",
        category: "E-Signature",
        docsUrl: "https://www.signnow.com/",
        icon: signnowIcon,
        accent: "#0075EB",
        fields: [
            {
                key: "apiKey",
                label: "API Key",
                helperText: "SignNow bearer API key",
                placeholder: "sn_live_…",
                secret: true,
            },
        ],
    },
    {
        id: "boldsign",
        name: "BoldSign",
        description:
            "Alternate e-sign provider for contract delivery and tracking.",
        category: "E-Signature",
        docsUrl: "https://boldsign.com/",
        icon: boldsignIcon,
        accent: "#FF4800",
        fields: [
            {
                key: "apiKey",
                label: "API Key",
                helperText: "BoldSign X-API-KEY value",
                placeholder: "bs_…",
                secret: true,
            },
        ],
    },
];

export function isOrganizationIntegrationActive(
    isActive: boolean | number | null | undefined,
): boolean {
    return isActive === true || isActive === 1;
}

export function getIntegrationById(
    id: string | undefined,
): IntegrationDefinition | null {
    if (!id) return null;
    return INTEGRATIONS.find((item) => item.id === id) || null;
}

export function isIntegrationId(id: string): id is IntegrationId {
    return INTEGRATIONS.some((item) => item.id === id);
}
